<rl-single-item-view
  [currentUserPermissions]="permissions"
  [item]="item"
  [isDraft]="isDraft"
  [listId]="listId"
  [listTitle]="item.list.title"
  [listUrl]="listUrl"
  [resourceEditUrl]="resourceEditUrl"
>
</rl-single-item-view>
